import {useInvoiceContext} from '../hooks/useInvoiceContext'
import {useEffect, useState} from 'react'
import {useAuthContext} from "../hooks/useAuthContext"
import '../styling/InvoiceList.css'
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config.js';


const InvoiceList = ({searchTerm}) => {
  const navigate = useNavigate();
  const {invoices, dispatch} = useInvoiceContext();
  const[deleteTrigger,setDeleteTrigger] = useState(false);
  const {user} = useAuthContext();

  const handleAccessClick = (invoiceId) => {
    // Navigate to the ClientDetails page with the specific client ID
    navigate(`/invoice/${invoiceId}`);
  };

  const handleDelete = async (invoice) => {
    
    if(!user){
      return
    }

    console.log(invoice)
    const response = await fetch(`${API_BASE_URL}/api/invoice/` + invoice._id, {
      method: "DELETE",
      headers:{
        "Authorization": `Bearer ${user.token}`
      }
    })

    const json = await response.json()

    if(response.ok){
      dispatch({type: "DELETE_INVOICES", payload:json})
      setDeleteTrigger(!deleteTrigger)
    }

  }

  useEffect(() => {
    const fetchClients = async () => {

        const response = await fetch(`${API_BASE_URL}/api/invoice`, {
            headers: {"Authorization": `Bearer ${user.token}`}
        })

        const json = await response.json()

        if(response.ok){
            dispatch({type: "SET_INVOICES", payload:json})
        }     
    }
    if (user){
        fetchClients()
    }  

// add clients to dependency below to update deleted client. 
  }, [dispatch,user, deleteTrigger])


  
  const filterInvoices = () => {
    if (searchTerm.trim() === '') {
      // If search term is empty, return all clients
      return invoices;
    }

    return invoices.filter(
      (invoice) =>{
      const clientMatches =
      invoice.client.clientFirst.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.client.clientLast.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.invoiceTotal.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.paymentDue.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.issuedDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.invoiceSubject.toLowerCase().includes(searchTerm.toLowerCase());

      const lineItemMatches = invoice.lineItems.some((lineItem) =>
      lineItem.productService.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Return true if either the client details or any line item matches the search term
    return clientMatches || lineItemMatches;
       } );
  };

    return ( 

        <div className="invoicelist">
            <div className="overflow-x-auto">
  <table className="table">
    {/* head */}
    <thead>
      <tr>
        <th>
          <label>
          </label>
        </th>
        <th>Name</th>
        <th>Invoice Subject</th>
        <th>Invoice Total</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {/* row 1 */}

      {invoices && filterInvoices().map((invoice) => {
  return (
    <tr key={invoice._id}>
      <th>
        <label>
        </label>
      </th>
      <td>
        <div className="flex items-center gap-3">
          <div className="avatar">
            <div className="mask mask-squircle w-12 h-12">
            </div>
          </div>
          <div>
            <div className="font-bold">{invoice.client.clientFirst} {invoice.client.clientLast}</div>
            <div className="text-sm opacity-50">{invoice.issuedDate}</div>
          </div>
        </div>
      </td>
      <td>
        {invoice.invoiceSubject}
      </td>
      <td>{invoice.invoiceTotal}</td>
      <th>
      <button className="btn" id="quoteaccess" onClick={() => handleAccessClick(invoice._id)}>
        Access
      </button>
      </th>
    </tr>
  );
})}


     
      </tbody>
    
  </table>
</div>
        </div>

    );
}
 
export default InvoiceList;